import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class SchemaService {
  private dataSubject = new BehaviorSubject<any>(false);
  private videoDataSubject = new BehaviorSubject<any>(false);
  private productData: any;
  private videoData: any;
  private subscription!: Subscription;
  sub: Subscription = new Subscription();

  constructor(public router: Router, public utils: UtilsService) { }

  addSchema() {
    let finalData;

    const activeRoute = this.utils.getActiveRouterWhileParams(this.router.url);
    const segments: any[] = activeRoute.split('/').filter(Boolean);
    if (segments.length === 0) {
      this.getSchema(segments).subscribe(breadcrumbSchema => {
        finalData = breadcrumbSchema
      });
    } else if (segments[0] === 'solar-application' ||
      segments[0] === 'product-listing' ||
      segments[0] === 'category' ||
      segments[0] === 'sub-category') {


      let schema: any = [], videoSchema: any = [], mergedSchema:any;
      this.subscription = this.videoDataSubject.subscribe(data => {
        this.getVideoSchema(segments, activeRoute, data).subscribe(videoSchemaData => {
          finalData = videoSchemaData;
        });
      });
      this.subscription = this.dataSubject.subscribe(data => {
        this.getSchema(segments,data, activeRoute ).subscribe(schemaData => {
          finalData = schemaData
        });
      });
      // this.updateSchema('schema', mergedSchema);
    } else if (segments[0] === 'product') {

      this.subscription = this.dataSubject.subscribe(data => {
        this.getSchema(segments, data).subscribe(breadcrumbSchema => {
          finalData = breadcrumbSchema
        });
      });
    } else if (segments[0] === 'blog' && segments[1] === 'post') {

      this.sub.add(this.subscription = this.dataSubject.subscribe(data => {
        this.getSchema(segments,data, activeRoute).subscribe(breadcrumbSchema => {
          finalData = breadcrumbSchema
        });
      }));

    } else if (segments[0] === 'ngsw-worker.js') {

    } else {

      this.sub.add(this.getSchema(segments).subscribe(breadcrumbSchema => {
        finalData = breadcrumbSchema
      }));
    }

    return finalData

    // }));
  }
  private updateSchema(id: string, schema?: object) {
    // if (schema[0]) {
    //   this.script  = this._renderer2.createElement('script');
    //   this.script.type = `application/ld+json`;
    // this.script.text = JSON.stringify(schema[0]);
    // this._renderer2.appendChild(this._document.body, this.script);
    return schema;
    // }
  }

  sendData(data: any) {
    this.productData = data;
    this.dataSubject.next(data);

  }
  sendVideoData(data: any) {
    this.videoData = data;
    this.videoDataSubject.next(data);
  }
  getSchema(segments?: any[], data?: any, activeRoute?: Object): Observable<object> {
    let typeData: string;
    if (segments?.length === 0) {
      return of({
        "@context": "https://schema.org/",
        "@type": "WebSite",
        "name": "Luminous Power Technologies",
        "url": "https://www.luminousindia.com/",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://www.luminousindia.com/search{search_term_string}",
          "query-input": "required name=search_term_string"
        }
      });
    } else if (
    segments?.[0] === 'solar-application' ||
    segments?.[0] === 'product-listing' ||
    segments?.[0] === 'category' ||
    segments?.[0] === 'sub-category') {
      const BreadcrumbList = [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home Page",
          "item": "https://www.luminousindia.com/"
        }
      ];
      segments?.forEach((segment: any, index: any) => {
        const listItem = {
          "@type": "ListItem",
          "position": index + 2,
          "name": this.formatName(segment),
          "item": `https://www.luminousindia.com/${segments?.slice(0, index + 1).join('/')}`
        };
        BreadcrumbList.push(listItem);
      });
      const itemListElement: any[] = [];
      if (Array.isArray(this.productData.length > 0)) {
        this.productData.forEach((segment: any, index: any) => {
          let nameData, urlData;
          if (segments?.[0] === 'solar-application') {
            nameData = segment?.seriesName;
            urlData = ''
          } else if (segments?.[0] === 'product-listing') {
            nameData = segment?.productName;
            urlData = `https://www.luminousindia.com/product/${nameData?.toLowerCase().replace(/\s+/g, '-')}`
          } else if (segments?.[0] === 'category') {
            nameData = segment?.subCategoryName || segment?.videoTitle;
            urlData = `https://www.luminousindia.com/product-listing/solar-solutions/${nameData?.toLowerCase().replace(/\s+/g, '-')}`
          } else if (segments?.[0] === 'sub-category') {
            nameData = segment?.videoTitle;
            urlData = `https://www.luminousindia.com/sub-category/${nameData?.toLowerCase().replace(/\s+/g, '-')}`
          }
          const listItem = {
            "@type": "ListItem",
            "position": index + 1,
            "name": this.formatName(nameData),
            "url": urlData
          };
          itemListElement.push(listItem);
        });
        return of({
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          "itemListElement": BreadcrumbList
        }, {
          "@context": "https://schema.org/",
          "@type": "ItemList",
          "itemListElement": itemListElement
        });
      } else {
        return of({
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          "itemListElement": BreadcrumbList
        });
      }
    } else if (segments?.[0] === 'product') {
      typeData = "Product";

      return of({
        "@context": "https://schema.org/",
        "@type": typeData,
        "name": data ? data?.productName : '',
        "image": data ? data?.featureImageFile : '',
        "description": data ? data?.shortDescription : '',
        "brand": {
          "@type": "Brand",
          "name": "Luminous"
        },
      });

    } else if (segments?.[0] === 'blog' && segments?.[1] === 'post') {
      typeData = "BlogPosting";

      return of({
        "@context": "https://schema.org",
        "@type": typeData,
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": `https://www.luminousindia.com${activeRoute}`
        },
        "headline": data?.postTitle,
        // "description": "Luminous inverter battery", // TODO:
        "image": data?.image,
        "author": {
          "@type": "Organization",
          "name": "Luminous",
          "url": "https://www.luminousindia.com/"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Luminous",
          "logo": {
            "@type": "ImageObject",
            "url": "" // TODO:
          }
        },
        "datePublished": this.formatDate(data?.postingDate)
      });
    } else {
      typeData = "ItemList";
      const itemListElement = [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home Page",
          "item": "https://www.luminousindia.com/"
        }
      ];

      segments?.forEach((segment: any, index: any) => {
        const listItem = {
          "@type": "ListItem",
          "position": index + 2,
          "name": this.formatName(segment),
          "item": `https://www.luminousindia.com/${segments?.slice(0, index + 1).join('/')}`
        };
        itemListElement.push(listItem);
      });

      return of({
        "@context": "https://schema.org/",
        "@type": typeData,
        "itemListElement": itemListElement
      });
    }
  }

  getVideoSchema(segments?: any[], activeRoute?: string, data?: Object): Observable<object> {
    let typeData: string;
    if (segments?.[0] === 'solar-application' || segments?.[0] === 'product-listing' || segments?.[0] === 'category' || segments?.[0] === 'sub-category') {
      const BreadcrumbList = [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home Page",
          "item": "https://www.luminousindia.com/"
        }
      ];
      segments?.forEach((segment: any, index: any) => {
        const listItem = {
          "@type": "ListItem",
          "position": index + 2,
          "name": this.formatName(segment),
          "item": `https://www.luminousindia.com/${segments?.slice(0, index + 1).join('/')}`
        };
        BreadcrumbList.push(listItem);
      });

      const itemListElement: any[] = [];
      if (this.videoData != undefined && this.videoData != '' && this.videoData != null) {
        this.videoData.forEach((segment: any, index: any) => {
          let nameData, urlData;
          if (segments?.[0] === 'solar-application') {
            nameData = segment?.videoTitle;
            urlData = ''
          } else if (segments?.[0] === 'product-listing') {
            nameData = segment?.videoTitle;
            urlData = `https://www.luminousindia.com/product/${nameData?.toLowerCase().replace(/\s+/g, '-')}`
          } else if (segments?.[0] === 'category') {
            nameData = segment?.videoTitle;
            urlData = `https://www.luminousindia.com/product-listing/solar-solutions/${nameData?.toLowerCase().replace(/\s+/g, '-')}`
          } else if (segments?.[0] === 'sub-category') {
            nameData = segment?.videoTitle;
            urlData = `https://www.luminousindia.com/sub-category/${nameData?.toLowerCase().replace(/\s+/g, '-')}`
          }
          const listItem = {
            "@type": "ListItem",
            "position": index + 1,
            "name": this.formatName(nameData),
            "url": urlData
          };
          itemListElement.push(listItem);
        });
        return of({
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          "itemListElement": BreadcrumbList
        }, {
          "@context": "https://schema.org/",
          "@type": "ItemList",
          "itemListElement": itemListElement.length > 0 ? itemListElement : ''
        });
      } else {
        return of({
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          "itemListElement": BreadcrumbList
        });
      }
    } else if (segments?.[0] === 'product') {
      return of({
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": this.videoData[0]?.productName,
        "description":  this.videoData?.shortDescription,
        "thumbnailUrl": this.videoData[0]?.iframeSrc,
        "uploadDate": this.formatDate(this.videoData[0]?.postingDate),
        "duration": "PT0M10S",
        "embedUrl": this.videoData[0]?.iframeSrc,
        "potentialAction": {
          "@type": "SeekToAction",
          "target": `${this.videoData[0]?.iframeSrc}={seek_to_second_number}`,
          "startOffset-input": "required name=seek_to_second_number"
        }
      });
    } else if (segments?.[0] === 'blog' && segments?.[1] === 'post') {
      typeData = "BlogPosting";
      if (this.videoData != undefined && this.videoData != '' && this.videoData != null) {
        return of({
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": this.videoData[0]?.postTitle,
          "description": "",
          "thumbnailUrl": this.videoData[0]?.iframeSrc,
          "uploadDate": this.formatDate(this.videoData[0]?.postingDate),
          "duration": "PT0M10S",
          "embedUrl": this.videoData[0]?.iframeSrc,
          "potentialAction": {
            "@type": "SeekToAction",
            "target": `${this.videoData[0]?.iframeSrc}={seek_to_second_number}`,
            "startOffset-input": "required name=seek_to_second_number"
          }
        });
      } else {
        return of([]);
      }
    } else {

      typeData = "ItemList";
      const itemListElement = [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home Page",
          "item": "https://www.luminousindia.com/"
        }
      ];

      segments?.forEach((segment: any, index: any) => {
        const listItem = {
          "@type": "ListItem",
          "position": index + 2,
          "name": this.formatName(segment),
          "item": `https://www.luminousindia.com/${segments?.slice(0, index + 1).join('/')}`
        };
        itemListElement.push(listItem);
      });
      return of([{
        "@context": "https://schema.org/",
        "@type": typeData,
        "itemListElement": itemListElement
      }]);
    }
  }

  private formatName(name: string): string {
    name = name.charAt(0).toUpperCase() + name.slice(1);
    name = name.replace(/-/g, ' ');
    return name;
  }

  private formatDate(date: string): string {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
  }
  gethomeSchema(): object {
    return {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Luminous Power Technologies Pvt. Ltd.",
      "url": "https://www.luminousindia.com/",
      "logo": "https://www.luminousindia.com/logo.png",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91-9999933039",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "en"
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91-9990299902",
          "contactType": "Energy Solutions",
          "areaServed": "IN",
          "availableLanguage": "en"
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91-8906008008",
          "contactType": "Sales",
          "areaServed": "IN",
          "availableLanguage": "en"
        }
      ],
      "sameAs": [
        "https://www.facebook.com/LuminousIndia",
        "https://twitter.com/LuminousIndia",
        "https://www.linkedin.com/company/luminous-power-technologies",
        "https://www.youtube.com/user/LuminousIndia"
      ],
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.luminousindia.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    };
  }
  private getBaseUrl(): string {
    // Assuming the base URL is the origin + the first part of the route
    const currentUrl = this.router.url.split('/')[1];
    return `https://www.luminousindia.com`;
  }
  private formatBreadcrumbName(segment: string): string {
    return segment
      .replace(/-/g, " ")
      .replace(/\b\w/g, char => char.toUpperCase());
  }
  addBreadcrumbSchema() {
    const baseUrl = this.getBaseUrl(); // Dynamically get base URL from router
    let segments = this.router.url.replace(baseUrl, "").split("/").filter(segment => segment);
  
    // Exclude the "product-listing" segment from the segments array
    segments = segments.filter(segment => segment.toLowerCase() !== "product-listing");
  
    // Determine whether to truncate after a specific segment (e.g., "post")
    const stopSegment = "post";
    const stopIndex = segments.findIndex(segment => segment.toLowerCase() === stopSegment.toLowerCase());
  
    let filteredSegments;
  
    if (stopIndex !== -1) {
      // Truncate at the "post" segment (inclusive)
      filteredSegments = segments.slice(0, stopIndex + 1);
    } else {
      // If "post" is not found, use all segments
      filteredSegments = segments;
    }
  
    // Generate breadcrumbs dynamically based on the filtered segments
    const breadcrumbs = filteredSegments.map((segment, index) => {
      const breadcrumbUrl = `${baseUrl}/${filteredSegments.slice(0, index + 1).join("/")}`;
      return {
        name: this.formatBreadcrumbName(segment),
        item: breadcrumbUrl,
      };
    });
  
    // Add the "Home Page" breadcrumb at the start
    breadcrumbs.unshift({
      name: "Home Page",
      item: baseUrl,
    });
  
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": breadcrumb.name,
        "item": breadcrumb.item,
      })),
    };
  }
  
  
  
  addItemlistSchema() {
    const baseUrl = this.getBaseUrl(); // Dynamically get base URL from router
    const segments = this.router.url.replace(baseUrl, "").split("/").filter(segment => segment);
  
    // Filter out the first segment (Home) and process the rest
    let filteredSegments = segments.length > 2 ? segments.slice(1, -1) : segments.slice(1);
  
    // Generate breadcrumbs dynamically based on the filtered segments
    const breadcrumbs = filteredSegments.map((segment, index) => {
      const breadcrumbUrl = `${baseUrl}/${filteredSegments.slice(0, index + 1).join("/")}`;
      return {
        name: this.formatBreadcrumbName(segment),
        item: breadcrumbUrl,
      };
    });
  
    // Add the last segment (e.g., "ampbox") to the breadcrumbs
    const lastSegment = segments[segments.length - 1];
    breadcrumbs.push({
      name: this.formatBreadcrumbName(lastSegment),
      item: `${baseUrl}/${segments.slice(0, segments.length).join("/")}`,
    });
  
    return {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": breadcrumb.name,
        "item": breadcrumb.item,
      })),
    };
  }
  
  createProductSchema(product: any) {
    if (!product) {
      console.error("Invalid product data passed to createProductSchema:", product);
      return {}; // Return an empty schema object if product is invalid
    }
  
    const baseUrl = this.getBaseUrl(); // Dynamically get base URL from router
    const segments = this.router.url; // Get current URL segments
  
    // Safely map reviews if available
    const reviews = product.reviewData?.reviews?.map((review: any) => ({
      "@type": "Review",
      "reviewBody": review?.description || "No description available",
      "author": {
        "@type": "Person",
        "name": review?.reviewerName || "Anonymous",
      },
    })) || [];
  
    // Safely handle aggregate rating properties
    const aggregateRating = product.reviewData?.reviews?.length
      ? {
          "@type": "AggregateRating",
          "ratingValue": product.reviewData?.reviews[0]?.rating || "0",
          "bestRating": "5", // Assuming 5 is the best rating
          "worstRating": "0", // Assuming 1 is the worst rating
          "ratingCount": product.reviewData.reviews.length,
        }
      : undefined; // Exclude this property if no reviews exist
  
    // Construct the schema object
    const schema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": product.productName || "Unknown Product", // Default value
      "image": product.featureImageFile || "", // Default to empty string if undefined
      "sku": product.productSKU || "", // Default to empty string if undefined
      "mpn":  "", // Default to empty string if undefined
      "url": `${baseUrl}${segments}`, // Concatenate base URL and current route
      "offers": {
        "@type": "Offer",
        "priceCurrency":"", // Default to USD
        "price": product.productMRP , // Default price to 0.00
        "url": `${baseUrl}${segments}`,
        "lowPrice": "", // Default to empty string
        "highPrice": "", // Default to empty string
        "offerCount":"", // Default to 0 offers
      },
      ...(aggregateRating && { "aggregateRating": aggregateRating }), // Include only if defined
      ...(reviews.length > 0 && { "review": reviews }), // Include reviews only if non-empty
    };
  
    return schema;
  }
  
  generateFaqJsonLd(faqs: any) {
    const faqlist: any[] = [];

    // Build the FAQPage JSON-LD object
    const faqJsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((faq: any) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": this.removeHtmlTags(faq.answer)
        }
      }))
    };   
   return faqJsonLd

  }
  removeHtmlTags(text: string): string {
    // Create a temporary DOM element
    const tempElement = document.createElement('div');
    
    // Set the text as innerHTML to allow the browser to parse the HTML
    tempElement.innerHTML = text;
    
    // Return the text content without any HTML tags
    return tempElement.textContent || tempElement.innerText || '';
  }
  addVideoSchema(data: any) {
    const videoList: any[] = [];
  
    // Generate video schema for each item in the media list
    data?.forEach((item: any) => {
      const videoItem = {
        "@context": "http://schema.org",
          "@type": "VideoObject",
          "name": item?.videoTitle,
          "description": "",
          "thumbnailUrl":item?.embededLink, // Use placeholder if no thumbnail is provided
          "uploadDate":"2020-08-01T08:00:00+08:00", // Defaults to current date if not provided
          "duration":"", // Default duration if not provided
          "embedUrl": item?.embededLink,
          "interactionCount":""// Default interaction count if not provided
      };
  
      videoList.push(videoItem);
    });
  
    return videoList; // Return the video schema array
  }
  getBlogSchemaData(data: any, url: string): any {
    return {
      "@context": "https://schema.org",
      "@type": 'BlogPosting',
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `https://www.luminousindia.com${url}`,
      },
      "headline": data?.postTitle,
      "description": data?.postDesc_tag,
      "image": data?.image,
      "author": {
        "@type": "Organization",
        "name": "Luminous",
        "url": `https://www.luminousindia.com${url}`,
      },
      "publisher": {
        "@type": "Organization",
        "name": "Luminous",
        "logo": {
          "@type": "ImageObject",
          "url": "", // Add logo URL dynamically if needed
        },
      },
      "datePublished": this.formatDate(data?.postingDate),
    };
  }
  }
  

